import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "footer",
  class: "bg-primary-500 flex flex-wrap md:flex-row sm:flex-col px-5 py-5 w-full"
}
const _hoisted_2 = { class: "flex flex-col space-y-2 px-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-200" }, " Copyright 2024 Yoda Pharmaceuticals Inc. All Rights Reserved. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "text-gray-100 cursor-pointer hover:text-first-500",
        to: "/contact"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Contact us")
        ]),
        _: 1
      }),
      _hoisted_3
    ])
  ]))
}